import { AccessGate, useCan } from '../../shared/access/AccessControls';
import React  from 'react';
import { DeliveryUsage } from '../../shared/types/deliveryUsage';
import { useEditMode } from '../../shared/hooks/useEditMode';
import Wrapper from '../../shared/components/Wrapper';
import EditModeSwitcher from '../../shared/components/EditModeSwitcher';
import UsageInfo from './UsageInfo';
import UsageForm from './UsageForm';

interface IUsageData {
  usage: DeliveryUsage;
}

const UsageData: React.FC<IUsageData> = ({ usage }) => {
  const canEdit = useCan('ADMIN_USAGE_UPDATE');
  const { edit, toggleEditMode, setEdit } = useEditMode();

  return (
    <Wrapper>
      <>
        <AccessGate action="ADMIN_USAGE_UPDATE"><EditModeSwitcher toggleEditMode={toggleEditMode} edit={edit} /></AccessGate>
        {(edit && canEdit && <UsageForm usage={usage} setEdit={setEdit} />) || (
          <UsageInfo usage={usage} />
        )}
      </>
    </Wrapper>
  );
};

export default UsageData;
